import * as Api from '@ViewModels';

/**
 * Determines if the current user is the owner of a shared phone number
 * @param sharedNumber The shared phone number configuration
 * @param currentUserId The current user's ID
 * @returns true if the current user is the owner (creator)
 */
export const isPhoneNumberOwner = (
	sharedNumber: Api.ITelephonyConfiguration | null,
	currentUserId: string
): boolean => {
	if (!sharedNumber) return false;
	return sharedNumber.creator?.id === currentUserId;
};

/**
 * Determines if call forwarding setup should be skipped for a shared number
 * @param sharedNumber The shared phone number configuration
 * @param currentUserId The current user's ID
 * @param isAdmin Whether the current user is an admin
 * @returns true if call forwarding setup should be skipped
 */
export const shouldSkipCallForwardingSetup = (
	sharedNumber: Api.ITelephonyConfiguration | null,
	currentUserId: string,
	isAdmin: boolean
): boolean => {
	// Non-owners always skip call forwarding setup
	if (!isPhoneNumberOwner(sharedNumber, currentUserId)) {
		return true;
	}

	// Owner skips if call forwarding is already configured
	if (sharedNumber?.callForwardingNumber != null) {
		return true;
	}

	// Owner skips if they are not an admin
	if (!isAdmin) {
		return true;
	}

	// Owner + no call forwarding + admin = needs setup
	return false;
};
